import {Label} from '@primer/react'
import {SecuritySeverity} from '../types/security-severity'

export type SecuritySeverityBadgeProps = {
  severity: SecuritySeverity
}

export function SecuritySeverityBadge({severity}: SecuritySeverityBadgeProps) {
  switch (severity) {
    case SecuritySeverity.Low:
      return <Label variant="primary">Low</Label>
    case SecuritySeverity.Medium:
      return <Label variant="attention">Medium</Label>
    case SecuritySeverity.High:
      return <Label variant="severe">High</Label>
    case SecuritySeverity.Critical:
      return <Label variant="danger">Critical</Label>
    case SecuritySeverity.None:
      return null
  }
}
